import Button from '@atoms/Button/Button';
import { TIMETABLE_ID } from '@constants/constants';
import useLocale from '@hooks/useLocale';
import useTranslations, { Translations } from '@hooks/useTranslations';
import CtaButton from '@molecules/CtaButton/CtaButton';
import { Cta } from '@type-declarations/cta';
import { Locale } from '@type-declarations/locale';
import { PreprDate } from '@type-declarations/prepr';
import formatDate from '@utils/formatDate';

import styles from './HeroCtas.module.scss';

const getDateLabel = (dates: PreprDate[], locale: Locale, t: Translations) => {
  if (dates.length > 1) {
    return `${t.until} ${formatDate({
      date: dates.at(-1)!.until,
      format: 'dd MMMM y',
      locale,
    })}`;
  }

  return formatDate({
    date: dates[0]!.from,
    format: 'dd MMMM y',
    locale,
  });
};

interface Props {
  mapId?: string;
  dates?: PreprDate[];
  cta?: Cta;
  website?: string;
}

export default function HeroCtas({ mapId, cta, dates, website }: Props) {
  const locale = useLocale();
  const t = useTranslations();

  return (
    <div className={styles.ctasContainer}>
      {!!dates?.length && (
        <Button
          label={getDateLabel(dates, locale, t)}
          iconLeft="CALENDAR"
          icon="NAV_ARROW_RIGHT"
          variant="white"
          fullWidth
          href={`#${TIMETABLE_ID}`} // link to time table in content
        />
      )}
      {!!cta && (
        <CtaButton
          cta={{ ...cta, icon: cta.icon || 'LINK' }}
          variant="white"
          fullWidth
        />
      )}
      {!!website && !cta && (
        <Button
          label={t.visitWebsite}
          icon="NAV_ARROW_RIGHT"
          href={website}
          variant="white"
          fullWidth
          iconLeft="LINK"
        />
      )}
      {mapId && (
        <Button
          label={t.planRoute}
          iconLeft="MAP_PIN"
          icon="NAV_ARROW_RIGHT"
          variant="white"
          fullWidth
          href={`#${mapId}`}
        />
      )}
    </div>
  );
}
